var fogNonePS = `
#ifndef PCFOG
#define PCFOG
uniform vec3 fog_color;
uniform float fog_density;
float dBlendModeFogFactor = 1.0;
const float MIN_DEPTH = 75.0;
vec3 addFog(vec3 color) {
	return color;
}
#endif
`;

export { fogNonePS as default };
